import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useRouteState() {
  const route = useRoute()
  const router = useRouter()

  return {
    name: computed(() => route.name),
    params: computed(() => route.params),
    query: computed(() => route.query),
    fullPath: computed(() => route.fullPath),
    updateQuery: (newQuery) => {
      router.replace({
        query: {
          ...route.query,
          ...newQuery,
        },
      })
    }
  }
}
